// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type XcpTeampermissionsUserResourcesQueryVariables = Types.Exact<{
  permissions?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type XcpTeampermissionsUserResourcesQuery = {
  __typename?: 'Query';
  viewer?: {
    __typename?: 'Viewer';
    id: string;
    teamPermissions?: {
      __typename?: 'TeamPermissionsViewer';
      userResources?: {
        __typename?: 'TeamPermissionsResourceRights';
        collection?: Array<{
          __typename?: 'TeamPermissionsResourceRight';
          permissions: Array<string>;
          resourceId: string;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export const XcpTeampermissionsUserResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'xcpTeampermissionsUserResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'permissions' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teamPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userResources' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'permissions' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'permissions' },
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'resourceType' },
                            value: { kind: 'EnumValue', value: 'PAGES' },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: {
                              kind: 'StringValue',
                              value: 'company',
                              block: false,
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'collection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'permissions',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceId' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  XcpTeampermissionsUserResourcesQuery,
  XcpTeampermissionsUserResourcesQueryVariables
>;
